export default __webpack_public_path__ + "12046eb1efec03fa4f9316bcc0522e0e.png";